import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCheckmarkOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M27.836 4.267a1 1 0 1 1 1.661 1.112L14.081 28.4a1.002 1.002 0 0 1-1.54.15l-9.25-9.299a1 1 0 1 1 1.417-1.41l8.39 8.433z" /></svg>;
export default SvgIconCheckmarkOutlined;